import React from 'react';
import { useSelector } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import Breadcrumbs from 'shared/app/components/breadcrumbs';
import { breadcrumbsSelector } from 'ordering/app/state/selectors';
import { commonMessages } from 'shared/app/messages';

const MenuBreadcrumbs = ({ className, breadcrumbBarStyling }) => {
  const breadcrumbs = useSelector(breadcrumbsSelector);
  const {
    categoryCrumb,
    selectedName = '',
    categoryName = '',
  } = breadcrumbs || {};

  const breadcrumbTrail = [
    {
      text: <FormattedMessage {...commonMessages.menuLabel} />,
      link: '/menu',
    },
  ];

  if (categoryCrumb) {
    if (categoryCrumb.text) {
      breadcrumbTrail.push({
        text: categoryCrumb?.text,
        link: categoryCrumb?.to,
      });
    }
    if (selectedName) {
      breadcrumbTrail.push({ text: selectedName });
    }
  } else if (categoryName) {
    breadcrumbTrail.push({ text: categoryName });
  }

  return (
    <Breadcrumbs
      breadcrumbBarStyling={breadcrumbBarStyling}
      breadcrumbs={breadcrumbTrail}
      className={className}
    />
  );
};

export default MenuBreadcrumbs;
